import { requestJson } from './requestJson';
import { buildApiUrl } from './apiUrl';

const NOTIFICATIONS_ENDPOINT = buildApiUrl('/api/notifications');

function authHeaders(accessToken) {
  if (!accessToken) {
    return {};
  }

  return {
    Authorization: `Bearer ${accessToken}`,
  };
}

export async function sendPendingRequestsNotification(accessToken) {
  return requestJson(NOTIFICATIONS_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(accessToken),
    },
    body: JSON.stringify({
      action: 'notifyAdminsPendingRequests',
    }),
  });
}